import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    disallowedChars: String
  }

  connect() {
    this.cleanInput()
  }

  preventDisallowedChars(event) {
    if (this.disallowedCharsValue.includes(event.key)) {
      event.preventDefault()
    }
  }

  cleanInput() {
    // Use setTimeout to ensure this runs after the paste completes
    setTimeout(() => {
      const regex = new RegExp(`[${this.disallowedCharsValue}]`, 'g')
      const cleanedValue = this.element.value.replace(regex, '')

      if (this.element.value !== cleanedValue) {
        this.element.value = cleanedValue
        // Trigger a change event so Rails forms notice the update
        this.element.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }, 0)
  }
}
